export default "__VITE_ASSET__Bt6TVttO__"